import React from 'react';

import { DialogV2, FormField, withForm } from '@gogame/form';
import { object, string } from '@gogame/schemas';

const presetSchema = object({
  title: string().required('Name is required'),
});

const PresetForm = withForm({
  validationSchema: presetSchema,
  enableReinitialize: true,
})(({ onClose, onExited, open, title }) => {
  return (
    <DialogV2
      open={open}
      onExited={onExited}
      onClose={onClose}
      disableEscapeKeyDown={true}
      fullWidth={true}
    >
      <DialogV2.Title title={title} />
      <DialogV2.Content>
        <FormField.TextField
          style={{ marginTop: '5px' }}
          name={'title'}
          label={'Name'}
          basis={'100%'}
          padding={'0'}
          autoFocus={true}
        />
      </DialogV2.Content>
      <DialogV2.Actions id={'add-preset-actions'}>
        <DialogV2.CloseButton />
        <DialogV2.SubmitButton />
      </DialogV2.Actions>
    </DialogV2>
  );
});

export default PresetForm;
